import { FdcpSeason } from 'fdcp/fdcp-types';

type TournamentDto = {
    id?: number;
    name: string;
    fdcpId?: string;
    ifesId?: string;
    startDate: Date | string;
    endDate: Date | string;
};

export const mapFdcpSeasonToTournamentDto = (season: FdcpSeason): TournamentDto => ({
    name: season.Name[0]?.Description || '',
    fdcpId: season.IdSeason,
    startDate: season.StartDate,
    endDate: season.EndDate,
    ifesId: season.Properties?.IdIFES,
});

export const sortTournamentsByStartDateDesc = (tournaments?: TournamentDto[]): TournamentDto[] =>
    [...(tournaments ?? [])].sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());

export default TournamentDto;
